import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MessageCircle, Menu, X, ArrowRight, ChevronDown } from 'lucide-react';
import Logo from './Logo';

const NAV_ITEMS = [
  { label: "Platform", path: "/platform", children: [
    { label: "Architecture", path: "/platform" },
    { label: "AI Brain", path: "/ai-brain" },
    { label: "Rewards Catalog", path: "/rewards" },
    { label: "Integrations", path: "/integrations" },
  ]},
  { label: "Program", path: "/solutions/channel-loyalty-program" },
  { label: "Solutions", path: "/solutions", children: [
    { label: "All 500+ Solutions", path: "/solutions" },
    { label: "Case Studies", path: "/case-studies" },
    { label: "Why ChannelLoyalty", path: "/why-channelloyalty" },
  ]},
  { label: "Industries", path: "/industries" },
  { label: "Resources", path: "/resources", children: [
    { label: "Blog", path: "/blog" },
    { label: "Channel Loyalty Report 2026", path: "/channel-loyalty-report-2026" },
    { label: "Press", path: "/press" },
  ]},
  { label: "Partners", path: "/partners" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar({ onDemoClick }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const location = useLocation();

  function isActive(path) {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }

  function handleDemoClick() {
    if (onDemoClick) {
      onDemoClick();
    }
  }

  return (
    <nav className="navbar" data-testid="main-navbar">
      <div className="container h-full">
        <div className="flex items-center justify-between h-full">
          <Link to="/" className="flex items-center gap-2">
            <Logo className="h-9" darkBg={false} />
          </Link>
          
          <div className="hidden md:flex items-center gap-7">
            {NAV_ITEMS.map(function(item) {
              if (item.children) {
                return (
                  <div 
                    key={item.label}
                    className="relative"
                    onMouseEnter={function() { setDropdownOpen(item.label); }}
                    onMouseLeave={function() { setDropdownOpen(null); }}
                  >
                    <button className={isActive(item.path) || isActive('/ai-brain') || isActive('/rewards') || isActive('/integrations') ? "font-semibold flex items-center gap-1 text-sm" : "nav-link flex items-center gap-1"} style={isActive(item.path) || isActive('/ai-brain') || isActive('/rewards') || isActive('/integrations') ? {color: '#2C39B8'} : {}}>
                      {item.label} <ChevronDown size={14} />
                    </button>
                    {dropdownOpen === item.label && (
                      <div className="absolute top-full left-0 mt-1 bg-white shadow-xl rounded-xl border border-gray-100 py-2 min-w-[200px] z-50">
                        {item.children.map(function(child) {
                          return (
                            <Link 
                              key={child.path}
                              to={child.path} 
                              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-[#2C39B8] transition-colors"
                              onClick={function() { setDropdownOpen(null); }}
                            >
                              {child.label}
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              }
              return (
                <Link 
                  key={item.path}
                  to={item.path} 
                  className={isActive(item.path) ? "font-semibold text-sm" : "nav-link"}
                  style={isActive(item.path) ? {color: '#2C39B8'} : {}}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
          
          <div className="hidden md:flex items-center gap-3">
            <a href="https://wa.me/919910059861" target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp">
              <MessageCircle size={18} /> WhatsApp
            </a>
            <Link to="/contact" className="btn btn-primary" data-testid="navbar-demo-btn">
              Schedule Demo <ArrowRight size={18} />
            </Link>
          </div>
          
          <button className="md:hidden p-2" onClick={function() { setMobileOpen(!mobileOpen); }} data-testid="mobile-menu-btn">
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {mobileOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">
          <div className="p-4 space-y-1">
            {NAV_ITEMS.map(function(item) {
              if (item.children) {
                return (
                  <div key={item.label}>
                    <div className="block py-2 px-3 text-gray-900 font-semibold text-sm">{item.label}</div>
                    {item.children.map(function(child) {
                      return (
                        <Link 
                          key={child.path}
                          to={child.path} 
                          className="block py-2 px-6 text-gray-600 hover:text-[#2C39B8] text-sm"
                          onClick={function() { setMobileOpen(false); }}
                        >
                          {child.label}
                        </Link>
                      );
                    })}
                  </div>
                );
              }
              return (
                <Link 
                  key={item.path}
                  to={item.path} 
                  className="block py-2 px-3 text-gray-700 hover:text-[#2C39B8] text-sm"
                  onClick={function() { setMobileOpen(false); }}
                >
                  {item.label}
                </Link>
              );
            })}
            <div className="pt-3 border-t mt-3 space-y-2">
              <a href="https://wa.me/919910059861" target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp w-full justify-center">
                <MessageCircle size={18} /> WhatsApp
              </a>
              <Link to="/contact" onClick={function() { setMobileOpen(false); }} className="btn btn-primary w-full justify-center">
                Schedule Demo <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
